define('standard',[
  'require',
  'jquery',

  // libs that needs initialisation
  'common/js/lib/Serum.Profile',
  'common/js/lib/Serum.Statistics',
  'common/js/lib/Serum.ScrollTrigger',
  'common/module/asset/Serum.Asset.Img',

  // libs continued..
  'common/js/lib/Pubsub',
  'common/js/lib/util/nrkno-embed',
  'common/js/lib/Serum.Time',
  'common/js/lib/Serum.Moment',
  'common/js/lib/Serum.Pubsub',
  'common/js/lib/Serum.Session',
  'common/js/lib/Serum.FontScale',
  'common/module/date/Serum.Date',
  'common/module/query/Serum.Query',
  'common/module/asset/Serum.Asset.Fragment',

  // polyfills
  'common/bower/console-polyfill/index',

  // 3rd party libs
  'signals',

  // jquery plugins
  'common/js/lib/jquery/plugins/jquery-throttle-debounce/1.1/jquery-throttle-debounce.min',

  // widgets
  'type/album/Serum.Album',
  'type/fact/Serum.Fact',
  'type/flow/Serum.Flow',
  'type/menu/Serum.MainMenu',
  'type/article/Serum.NewsArticle',
  'type/article/Serum.FeatureArticle',
  'type/sharing/Serum.Sharing'
], function(require, $, Profile, Statistics, ScrollTrigger, Img, Pubsub, NrknoEmbed) {
  'use strict';

  var initialized = false;

  return {
    initialize: function () {
      if (!initialized) {
        Statistics.initialize();
        Profile.initialize();
        ScrollTrigger.initialize();
        Img.initialize();
        NrknoEmbed.initialize();
        initialized = true;
      }
    }
  };
});

